import React, { Component } from "react";
import { Button } from "antd";
// import F from "../../../Functions";
import { Translate } from "react-translated";

class ShowHideStats extends Component {
  renderShowStatsButton = () => {
    let { updateExpandState, applyParentDivOnShowStatsButton } = this.props;

    const SHOW_STATS_BUTTON = (
      <Button
        type="primary"
        size="large"
        onClick={updateExpandState}
        className="show_stats"
      >
        <Translate text={`Show`} />
      </Button>
    );
    return applyParentDivOnShowStatsButton ? (
      <div className="show_stats">{SHOW_STATS_BUTTON}</div>
    ) : (
      SHOW_STATS_BUTTON
    );
  };
  renderHideStatsButton = () => {
    let { updateExpandState } = this.props;
    return (
      <div className="hideStatsContainer">
        <Button
          type="primary"
          size="large"
          className="hide_stats"
          onClick={updateExpandState}
        >
          <Translate text={`Hide`} />
        </Button>
      </div>
    );
  };
  render() {
    let { expandStats } = this.props;

    return !expandStats
      ? this.renderShowStatsButton()
      : this.renderHideStatsButton();
  }
}

export default ShowHideStats;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/show-hide-stats.js